<template>
  <div>
    <van-dialog
      v-model="editState"
      title="修正数量"
      show-cancel-button
      :before-close="beforeClose"
      @confirm="onClickOpen"
      @cancel="onClickClose"
    >
      <div class="edit">
        <span>采购数量:&nbsp;&nbsp;{{commodityData.number}}件</span>
        <p class="edit-one">
          <span>修正数量</span>
          <van-stepper async-change v-model="purchaseData" @change="stepperChange"/>
        </p>
        <p>最终采购数量:&nbsp;&nbsp;{{purchaseData}}件</p>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { Toast } from 'vant';
export default {
  props: {
    commodityData: {}
  },
  data() {
    return {
		  editState:true,
      resultData:'0', //最终采购数量
      purchaseData: "0" //采购数量
    };
  },
  created() {
    this.purchaseData = this.commodityData.number;
  },
  methods: {
    stepperChange(v) {
      if (v < 1) {
        this.purchaseData = 1;
      }
    },
    onClickOpen() {
      this.$emit("onClickOpen", this.purchaseData);
    },
    // 关闭
    onClickClose() {
      this.$emit("onClickClose");
    },
    // 修改数量
 //    onChangeNum(item) { //  Toast.loading({ forbidClick: true });
	// this.purchaseData = item;
 //      //   setTimeout(() => {
 //      //   // Toast.clear();
 //      //   // 注意此时修改 value 后会再次触发 change 事件
 //      //   this.purchaseData = item;
 //      // }, 500);
 //    }
  }
};
</script>
<style lang="scss" scoped>
.edit {
  padding: 25px 39px 40px 43px;
  width: 100%;
  & > span {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }
  & > p:nth-child(3) {
    margin-top: 28px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .edit-one {
    // border: 1px solid red;
    width: 100%;
    position: relative;
    margin-top: 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    & > span {
      float: left;
      position: absolute;
      font-size: 28px ;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      margin-left: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/completeRecords/details/edit.vue